/**
 * Created by Andrey Popov 20 apr 2020
 */

const TileBadge = cc.Sprite.extend({
    ctor: function (options) {
        options = options || {};

        this._super(bundles.badge.frames.badge_png);

        const styles = cleverapps.styles.TileBadge;
        const rotation = options.rotation !== undefined ? options.rotation : styles.rotation;
        const textRotation = options.textRotation !== undefined ? options.textRotation : styles.text.rotation;

        if (options.icon) {
            options.icon.setAlignment(styles.icon);
            options.icon.setRotation(rotation * -1);
            this.addChild(options.icon);
        } else {
            const font = options.largeFont ? cleverapps.styles.FONTS.TILE_SHOP_BADGE_BIG : cleverapps.styles.FONTS.TILE_SHOP_BADGE_TEXT;
            const text = cleverapps.UI.generateOnlyText(this.chooseText(options), options.font || font);
            text.setAlignment(styles);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.fitTo(styles.width, styles.height);
            text.setRotation(textRotation);
            this.addChild(text);
        }

        if (options.tooltipText) {
            cleverapps.tooltipManager.create(this, {
                text: Messages.get(options.tooltipText),
                position: styles.tooltip.position,
                size: styles.tooltip.size
            });
        }

        if (options.clickAction) {
            this.createFinger();
            cleverapps.UI.applyHover(this);
            cleverapps.UI.onClick(this, options.clickAction);
        }

        this.setRotation(rotation);
    },

    disable: function () {
        this.setSpriteFrame(bundles.badge.frames.badge_off_png);
    },

    enable: function () {
        this.setSpriteFrame(bundles.badge.frames.badge_png);
    },

    chooseText: function (options) {
        if (options.type === "discount") {
            return Messages.get("Badge.discount", {
                amount: options.text
            });
        }

        if (options.type === "save") {
            return Messages.get("Badge.save");
        }

        if (options.type === "bestSeller") {
            return Messages.get("Badge.bestSeller");
        }

        if (options.type === "value") {
            return Messages.get("Badge.Value", {
                amount: options.value
            });
        }

        return options.text || "default";
    },

    createFinger: function () {
        FingerView.hintTap(this, {
            delay: 0.8,
            runOnce: true
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TILE_SHOP_BADGE_TEXT: {
        size: 25,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_BADGE_STROKE
    },

    TILE_SHOP_BADGE_BIG: {
        size: 46,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_BADGE_STROKE
    }
});

cleverapps.styles.TileBadge = {
    x: { align: "center", dx: 0 },
    y: { align: "center", dy: 10 },
    width: 125,
    text: {
        rotation: 0
    },
    rotation: 30,

    tooltip: {
        position: {
            x: { align: "center", dx: -75 },
            y: { align: "top", dy: 50 }
        },
        size: {
            width: 500,
            height: 100
        }
    },

    icon: {
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: 8 }
    }
};
